import React, { FC } from 'react';
import cs from 'classnames';
import s from './SearchSuggestionButton.scss';

interface SearchSuggestionButtonProps {
  children?: React.ReactNode;
  onClick: () => void;
  isActive?: boolean;
  className?: string;
}

export const SearchSuggestionButton: FC<SearchSuggestionButtonProps> = ({
  onClick,
  isActive,
  className,
  children,
}) => {
  return (
    <button
      onClick={onClick}
      className={cs(s.button, className, {
        [s.active]: isActive,
      })}
    >
      {children}
    </button>
  );
};
